// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2iGtV","imageUploader":"EGiftCard_imageUploader__732Ig"};